import { Box, SystemIcon, Typography } from '@wishket/design-system';

import { Link } from '@/shared/Components';
import { PATH } from '@/shared/constants';

interface RecentSearchItemProps {
  recentSearch: string;
  onClickDeleteRecentSearchItemButton?: () => void;
  onClose: () => void;
}

export const RecentSearchItem = ({
  recentSearch,
  onClickDeleteRecentSearchItemButton,
  onClose,
}: RecentSearchItemProps) => {
  return (
    <Box className="flex items-center justify-between">
      <Link
        href={`${PATH.LIST_SEARCH}?q=${recentSearch}`}
        className="w-full"
        onClick={onClose}
      >
        <Typography variant="body1" className="truncate text-w-gray-600">
          {recentSearch}
        </Typography>
      </Link>
      <button
        className="flex-shrink-0"
        onClick={onClickDeleteRecentSearchItemButton}
      >
        <SystemIcon name="medium_delete" className="text-w-gray-600" />
      </button>
    </Box>
  );
};

export const EmptyRecentSearches = () => {
  return (
    <Box className="flex items-center justify-center">
      <Typography variant="body1" className="text-w-gray-600">
        최근 검색어가 없어요.
      </Typography>
    </Box>
  );
};
